import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback, useMemo } from 'react';
import GridCellBase from 'src/components/GridCellBase';
import useRedirect from 'src/hooks/useRedirect';

const GoToPoEnterReceipts = (props: GridCellProps) => {
  const { getUrl, redirect } = useRedirect();
  const value = useMemo(
    () => ('document' in props.dataItem ? props.dataItem.document : props.dataItem.poNum),
    [props.dataItem]
  );

  const handleClick = useCallback(() => {
    redirect(getUrl('poDetails')(props.dataItem.poId), true);
  }, [getUrl, props.dataItem.poId, redirect]);

  return (
    <GridCellBase {...props} title={value} rowSelectionEnabled={true}>
      <button onClick={handleClick} className="text-link cursor-pointer text-underline">
        {value}
      </button>
    </GridCellBase>
  );
};

export default GoToPoEnterReceipts;
